/**
 * useStudioNav — Navigation helper for studio routes
 * Wraps useNavigate to implement scroll-to-top + carry params
 */

import { useNavigate } from "react-router-dom";
import { useStudioStore } from "./studio-context";

interface StudioNavOptions {
	project?: string;
	tab?: string;
	filter?: string;
}

export function useStudioNav() {
	const navigate = useNavigate();
	const { activeProjectId } = useStudioStore();

	const nav = (path: string, opts?: StudioNavOptions) => {
		window.scrollTo({ top: 0, behavior: "smooth" });

		const hasQuery = path.includes("?");

		if (opts?.project) {
			const projectParam = `project=${opts.project}`;
			path = hasQuery ? `${path}&${projectParam}` : `${path}?${projectParam}`;
		}
		if (opts?.tab) {
			const tabParam = `tab=${opts.tab}`;
			path = path.includes("tab=")
				? path.replace(/tab=[^&]*/, tabParam)
				: hasQuery || opts?.project
					? `${path}&${tabParam}`
					: `${path}?${tabParam}`;
		}
		if (opts?.filter) {
			const filterParam = `filter=${opts.filter}`;
			path = path.includes("filter=")
				? path.replace(/filter=[^&]*/, filterParam)
				: hasQuery || opts?.project || opts?.tab
					? `${path}&${filterParam}`
					: `${path}?${filterParam}`;
		}

		navigate(path);
	};

	return {
		nav,
		activeProjectId,
	};
}
